import { Container } from "react-bootstrap";
import {
  IconButton,
  Box, 
  Button,
  Card,
  FormControl,
  Grid, 
  InputAdornment, 
  makeStyles,
  MenuItem,
  OutlinedInput,
  Select,
  SwipeableDrawer,
  TextField, 
  useMediaQuery,
  Tooltip
} from "@material-ui/core";
import SearchIcon from '@mui/icons-material/Search';
import ButtonList from "./Controls/ButtonList";
import MultiCritere from "./Accordions/MultiCritere";
import { useState, useCallback,useEffect, useRef } from "react";
import "./dashboardStyle.css"
import { getAllSearchLists, resolveCandidatesForIa, agentTextSearch } from "../Services/SearchService";
import { updateObjectStateValue } from "../../utils/FunctionHelpers";
import { withSnackbar } from "../../utils/SnackbarHOC";
import FilterListIcon from '@mui/icons-material/FilterList';
import { useSelector } from "react-redux";
import {useLocation} from "react-router-dom";

const useStyles = makeStyles(() => ({
  searchByName: {
    padding: "15px",
    justifyContent: "center",
  },
  title: {
    color: "#117aa7",
    fontWeight: 700,
    fontFamily: "myFont",
  },
  classHeading: {
    color: "white",
  },
  multi2: {
    marginRight: "1.5em",
    width: "100%",
  },
  MuiTypographyCaption: {
    fontWeight: 700,
  },
  fontStyle: {
    fontFamily: "myFont",
    fontSize: "14px",
  },
}));

const getInitialParameters = () => {
  const location = window.location.search
  if (location) {
    const searchParams = new URLSearchParams(location);
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params;
  }

  return {
    prenom: "",
    categorie: "candidat",
    motsCleCategorie: "fonction",
  };
};

const Search = ({
  candidatsData,
  societesData,
  contactsData,
  handleSearch,
  snackbarShowMessage,
  history,
  onIaActivate,
  onIaDeactivate,
}) => {
  const classes = useStyles();
  const location = useLocation();
  const restoredAgentQueryRef = useRef("");

  const [nomFamille, setNomFamille] = useState(false);
  const [searchMode, setSearchMode] = useState("or");


  const [motsCleCategorie, setMotsCleCategorie] = useState("tous");
  const [multiOpen, setMultiOpen] = useState(false);
  const [searchKeys, setSearchKeys] = useState({
    motsCle: [],
    societe: "",
    selection: ""
  })
  const [loading, setLoading] = useState(false)
  const [selectionsData, setSelectionsData] = useState({
    societes: {
      data: []
    },
    selections: {
      data: []
    },
    competenceMetier: [],
    competenceSecto: [],
    consultants: [],
    managers: []
  });
  const selectedCandidatForSelection = useSelector((state) => state.candidats.candidatsSelectedForSelection);
  const [parameters, setParameters] = useState(getInitialParameters);

  const getUserData = () => JSON.parse(localStorage.getItem("userData"));
  const connectedUser = getUserData();
  const connectedUserId =
      connectedUser?.uuid || connectedUser?.id || connectedUser?.userId || "";

  const addParam = useCallback((e) => {
    const { name, value } = e.target;

    setParameters((prevParameters) => ({
      ...prevParameters,
      [name]: value || "",
    }));
  }, []);

  const settingUpListsForAutoComplete = (idKeyName, valueKeyName, data) => {
    return data.map(({
      [idKeyName]: id,
      [valueKeyName]: value,
      ...rest
    }) => ({
      id,
      value,
      ...rest
    }));
  }


  useEffect(() => {
    if (multiOpen) {
      let active = true;
      setLoading(true);
      (async () => {
        try {
          const { data } = await getAllSearchLists();
          if (!active) {
            return;
          }
          const setupSocietes = settingUpListsForAutoComplete("uuid", "nom_societe", data.societes)
          updateObjectStateValue(setSelectionsData, {
            societes: {
              data: setupSocietes,
              isLoading: loading
            },
            selections: {
              data: data.selections,
              isLoading: loading,
              label: 'SÉLECTIONS'
            },
            consultants: data.consultants,
            managers: data.managers,
            competenceSecto: data.competencesSectorielles,
            competenceMetier: data.competencesMetiers
          })
        } catch (error) {
          snackbarShowMessage("Erreur de chargement des listes.", "error", 4000)
        } finally {
          setLoading(false);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multiOpen]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      history.push(`/accueil/chercher?${new URLSearchParams(parameters).toString()}`);
    }
  };

  useEffect(() => {
    setParameters((prevParameters) => ({
      ...prevParameters,
      ...( { 'searchKeys': searchKeys?.motsCle?.length ? searchKeys.motsCle.join('|') :"" }),
      ...(searchKeys?.societe?.id ? { 'societe': searchKeys?.societe?.id } : {}),
      ...(searchKeys?.selection?.id ? { 'selection': searchKeys.selection.id } : {}),
      searchMode
    }));
  }, [searchKeys.motsCle, searchKeys?.societe, searchKeys.selection, searchMode]);


  const handleNameChecked = (e) => {
    const { checked } = e.target;
    const paramName = checked ? "prenom" : "nom";
    const otherParamName = checked ? "nom" : "prenom";
    const { [paramName]: temp, ...newParameters } = parameters;
    setParameters({ ...newParameters, [otherParamName]: temp });
    setNomFamille(checked);
  };


  const handleSearchModeChange = (event) => {
    setSearchMode(event.target.value);
  };

  const handleCategorieChange = (e) => {
    addParam(e);
    const newParams = { ...parameters, categorie: e.target.value };
    history.push(`/accueil/chercher?${new URLSearchParams(newParams).toString()}`);
  };

  const extractCandidatesFromIaResolve = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.candidats)) return payload.candidats;
    if (Array.isArray(payload?.candidates)) return payload.candidates;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.items)) return payload.items;
    return [];
  };

  const resolveCandidateIdFromRow = (row = {}) =>
      row.id ?? row.uuid ?? row.candidatId ?? row.candidat_id ?? row.candidatUuid ?? row.candidat_uuid ?? null;

  const getScoreForResolvedCandidate = (candidate = {}, scoreMap = new Map()) => {
    const uploadedFiles = Array.isArray(candidate.uploadedFiles) ? candidate.uploadedFiles : [];
    const idsToTry = [
      resolveCandidateIdFromRow(candidate),
      ...uploadedFiles.map((f) => f?.id ?? f?.uuid ?? null),
    ].filter(Boolean);
    for (const key of idsToTry) {
      const score = scoreMap.get(String(key));
      if (score != null) return score;
    }
    return null;
  };

  const handleAgentSearch = useCallback(async (text) => {
    if (!text?.trim()) return;
    onIaActivate?.({ data: [], isLoading: true });
    setMultiOpen(false);
    try {
      const res = await agentTextSearch(text, connectedUserId);
      if (res.data?.agent_error) {
        snackbarShowMessage(
          "L'agent IA n'a pas trouvé de résultats. Reformulez votre recherche.",
          "warning",
          5000
        );
        onIaActivate?.({ data: [], isLoading: false });
        return;
      }

      const agentCandidates = Array.isArray(res.data?.Candidates)
          ? res.data.Candidates
          : Array.isArray(res.data?.Jobs)
              ? res.data.Jobs.map(j => ({ ...j, id: j.uuid ?? j.id }))
              : [];

      if (agentCandidates.length === 0) {
        onIaActivate?.({ data: [], isLoading: false });
        return;
      }

      const fallbackCandidates = agentCandidates
          .sort((a, b) => (b.score ?? 0) - (a.score ?? 0))
          .map((c) => {
            const p = c.properties || {};
            const nameParts = (p.full_name || "").trim().split(/\s+/).filter(Boolean);
            const id = resolveCandidateIdFromRow(c) ?? c.id;
            return {
              ...c,
              candidat_uuid: c.candidat_uuid ?? id,
              id,
              ia_score: c.ia_score ?? c.score ?? null,
              nom: c.nom || p.last_name || nameParts.slice(1).join(" ") || "",
              prenom: c.prenom || p.first_name || nameParts[0] || "",
              email: c.email || (p.email !== "not found" ? p.email : ""),
              telephone: c.telephone || (p.phone !== "not found" ? p.phone : ""),
              fonction: c.fonction || p.roles_held?.[0] || "",
              localisation: c.localisation || p.location || "",
              numCandidat: c.numCandidat ?? null,
              updatedAt: c.updatedAt ?? null,
              selections: Array.isArray(c.selections) ? c.selections : [],
              uploadedFiles: Array.isArray(c.uploadedFiles) ? c.uploadedFiles : [],
            };
          });

      const sortedAgentCandidates = [...agentCandidates].sort((a, b) => (b.score ?? 0) - (a.score ?? 0));
      const scoreByAgentId = new Map(
          sortedAgentCandidates.filter((c) => c?.id).map((c) => [String(c.id), c.score ?? 0])
      );
      const agentIds = sortedAgentCandidates.map((c) => c?.id).filter(Boolean);

      let candidates = [];
      if (agentIds.length > 0) {
        try {
          const resolved = await resolveCandidatesForIa(agentIds);
          const resolvedRows = extractCandidatesFromIaResolve(resolved?.data);
          const normalizedRows = resolvedRows
              .filter(Boolean)
              .map((row) => {
                const id = resolveCandidateIdFromRow(row);
                return {
                  ...row,
                  id,
                  candidat_uuid: row.candidat_uuid ?? id,
                  ia_score: getScoreForResolvedCandidate(row, scoreByAgentId),
                  uploadedFiles: Array.isArray(row.uploadedFiles) ? row.uploadedFiles : [],
                };
              })
              .sort((a, b) => (b.ia_score ?? -1) - (a.ia_score ?? -1));

          const seenIds = new Set();
          candidates = normalizedRows.filter((row) => {
            const key = row?.id ? String(row.id) : null;
            if (!key || seenIds.has(key)) return false;
            seenIds.add(key);
            return true;
          });
        } catch {
          candidates = [];
        }
      }

      if (candidates.length === 0) candidates = fallbackCandidates;
      onIaActivate?.({ data: candidates, isLoading: false });
    } catch {
      snackbarShowMessage("Erreur de recherche par agent IA.", "error", 4000);
      onIaActivate?.({ data: [], isLoading: false });
    }
  }, [onIaActivate, snackbarShowMessage, connectedUserId]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const isAiSearch = searchParams.get("isAiSearch") === "true";
    const iaMode = searchParams.get("iaMode");
    const agentTextFromUrl = (searchParams.get("agentText") || "").trim();

    if (!(isAiSearch && iaMode === "agent" && agentTextFromUrl)) {
      restoredAgentQueryRef.current = "";
      return;
    }
    if (restoredAgentQueryRef.current === agentTextFromUrl) return;
    restoredAgentQueryRef.current = agentTextFromUrl;
    handleAgentSearch(agentTextFromUrl);
  }, [location.search, handleAgentSearch]);

  const multiCritereProps = {
    classes,
    motsCleCategorie,
    setMotsCleCategorie,
    multiOpen,
    setMultiOpen,
    addParam,
    parameters,
    searchKeys,
    setSearchKeys,
    loading,
    selectionsData,
    handleSearch,
    handleNameChecked,
    searchMode,
    handleSearchModeChange,
    nomFamille,
    onAgentSearch: handleAgentSearch,
  };

  const isSmall = useMediaQuery((theme) => theme.breakpoints.between(0, 767));
  const isMediumMode = useMediaQuery((theme) => theme.breakpoints.between(767, 1023));

  return (
    <Container >
      <Card className={classes.searchByName} style={{ position: "center" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h4 className={classes.title}>RECHERCHE</h4>
          <Box sx={{ display: "flex" }}>
            {candidatsData.loadCandidats || societesData.loadSociete || contactsData.loadContacts ? <ButtonList loading={loading} selectedCandidats={selectedCandidatForSelection}></ButtonList> : ""}
            <Button startIcon={<FilterListIcon />} onClick={() => setMultiOpen(true)} className={classes.fontStyle} style={{ color: "#117aa7" }}>
              FILTRER
            </Button>
          </Box>

        </Box>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" fullWidth margin="normal">
              <Select
                className={classes.fontStyle}
                value={parameters && parameters.categorie}
                name="categorie"
                onChange={handleCategorieChange}
                input={<OutlinedInput name="categorie" />}
              >
                {["candidat", "contact", "societe"].map((category) => (
                  <MenuItem
                    value={category}
                    key={category}
                    className={classes.fontStyle}
                  >
                    {category.toUpperCase()}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            xs={12}
            {...(multiOpen
              ? { md: 9, style: { transition: "ease", transitionDuration: "0.3s" } }
              : { md: 9, style: { transition: "ease", transitionDuration: "0.2" } })}
          >
            <TextField
              {...(nomFamille ? { name: "nom" } : { name: "prenom" })}
              value={parameters && parameters.nom ? parameters.nom : parameters.prenom}
              onChange={(e) => {
                addParam(e);
              }}
              variant="outlined"
              autoComplete="off"
              fullWidth
              placeholder="Nom ou N° de dossier ou N° de téléphone ou Lien LKD"
              margin="normal"
              onKeyDown={handleKeyPress}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Rechercher">
                      <IconButton
                        onClick={() => history.push(`/accueil/chercher?${new URLSearchParams(parameters).toString()}`)}
                        size="small"
                        aria-label="search"
                      >
                        <SearchIcon />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                )

              }}
            />
          </Grid>
        </Grid>
      </Card>
      <SwipeableDrawer
        anchor="right"
        open={multiOpen}
        onClose={() => setMultiOpen(false)}
        onOpen={() => setMultiOpen(true)}
      >
        <Box sx={{ width: isSmall || isMediumMode ? "60vw" : "35vw" }}>
          <MultiCritere {...multiCritereProps} />
        </Box>
      </SwipeableDrawer>
    </Container >
  )
}

export default withSnackbar(Search);
